import { render, staticRenderFns } from "./server-info.vue?vue&type=template&id=b89f5ab6&scoped=true&"
import script from "./server-info.vue?vue&type=script&lang=js&"
export * from "./server-info.vue?vue&type=script&lang=js&"
import style0 from "./server-info.vue?vue&type=style&index=0&id=b89f5ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89f5ab6",
  null
  
)

export default component.exports